
import React from "react";
import usePrivateLink from "../config/usePrivateLink";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const menuItems = [
  {
    id: "feesReport",
    path: "/fees/report",
    title: "Fees Report",
    icon: "ri-file-chart-2-line",
  },
  {
    id: "feesTxn",
    path: "/fees/transactions",
    title: "Fees Transactions",
    icon: "ri-exchange-dollar-line",
  },
  {
    id: "dueFeesTypeWise",
    path: "/student/due/fee/type-wise",
    title: "Due Fees Type Wise",
    icon: "ri-pie-chart-2-line",
  },
  {
    id: "batchFeeReport",
    path: "/batch/fee/report",
    title: "Batch Fee Report",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "discountFeeReport",
    path: "/fee/discount/report",
    title: "Discount Fees Report",
    icon: "ri-price-tag-3-line",
  },
  {
    id: "pendingFeeTxn",
    path: "/all/fees/transactions",
    title: "Pending Fee Transactions",
    icon: "ri-time-line",
    activePaths: [
      "/all/fees/transactions",
      "/student/fees/transaction/history",
    ],
  },
  {
    id: "manualFeeDeposit",
    path: "/student/manual/fee/deposit",
    title: "Manual Fee Deposit",
    icon: "ri-hand-coin-line",
  },
  {
    id: "allFeeTxn",
    path: "/fees/transactions/v2",
    title: "All Fee Transactions",
    icon: "ri-money-rupee-circle-line",
  },
  {
    id: "familyFeeDeposit",
    path: "/family/fees/deposit",
    title: "Family Fee Deposit",
    icon: "ri-group-line",
  },
];

export default function Master({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const visibleTabs = menuItems.filter((item) => {
    const routes = item.activePaths?.length
      ? item.activePaths
      : [item.path];

    return routes.some((route) => hasAccess(route));
  });

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}
